import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ServiceOption } from '@core/models';

@Component({
  selector: 'app-service-suggestion-picker',
  imports: [CommonModule],
  templateUrl: './service-suggestion-picker.component.html',
  styleUrl: './service-suggestion-picker.component.scss',
})
export class ServiceSuggestionPickerComponent {
  @Input({ required: true }) query = '';
  @Input({ required: true }) suggestions: ServiceOption[] = [];
  @Input() selectedIds: string[] = [];
  @Input() loading = false;
  @Input() placeholder = 'Ej: frenos, cambio de aceite...';

  @Output() queryChange = new EventEmitter<string>();
  @Output() refreshRequested = new EventEmitter<void>();
  @Output() serviceAdded = new EventEmitter<ServiceOption>();

  get filteredSuggestions(): ServiceOption[] {
    const blocked = new Set(this.selectedIds);
    const available = this.suggestions.filter((item) => !blocked.has(item.id));
    const normalized = this.query.trim().toLowerCase();

    if (!normalized) {
      return available.slice(0, 8);
    }

    return available.filter((item) => this.getServiceLabel(item).toLowerCase().includes(normalized));
  }

  get showSuggestions(): boolean {
    return this.loading || this.filteredSuggestions.length > 0 || this.query.trim().length > 0;
  }

  onInput(event: Event): void {
    const value = (event.target as HTMLInputElement | null)?.value ?? '';
    this.queryChange.emit(value);
  }

  onFocus(): void {
    this.refreshRequested.emit();
  }

  onAdd(service: ServiceOption): void {
    this.serviceAdded.emit(service);
  }

  getServiceLabel(service: ServiceOption): string {
    const serviceName = service.service?.name || 'Servicio';
    const categoryName = service.category?.name || '';
    return categoryName ? `${categoryName} - ${serviceName}` : serviceName;
  }
}

